const getRecordPermission = async (): Promise<boolean> => {
  try {
    // Request microphone permissions first to ensure we get device labels
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    })
    for (const track of stream.getTracks()) {
      track.stop()
    } // Stop the stream immediately since we only needed it for permissions
    return true
  } catch (error) {
    // User denied permission
    return false
  }
}

export const getInputDevices = async (): Promise<MediaDeviceInfo[]> => {
  const hasPermission = await getRecordPermission()
  if (!hasPermission) {
    console.error(
      'User has denied microphone access. Returning empty devices list.'
    )
  }
  const devices = await navigator.mediaDevices.enumerateDevices()
  return devices.filter((device) => device.kind === 'audioinput')
}
